import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createTopicEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackFollowTheme = (source: PosthogTrackingSource, themeId: string) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_FOLLOWED,
      properties: { source, following_type: 'theme', following_id: themeId },
    });

  const trackUnfollowTheme = (source: PosthogTrackingSource, themeId: string) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_UNFOLLOWED,
      properties: { source, following_type: 'theme', following_id: themeId },
    });

  const trackFollowGeography = (
    source: PosthogTrackingSource,
    geographyCode: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.GEOGRAPHY_FOLLOWED,
      properties: {
        source,
        following_type: 'geography',
        following_id: geographyCode,
      },
    });

  const trackUnfollowGeography = (
    source: PosthogTrackingSource,
    geographyCode: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.GEOGRAPHY_UNFOLLOWED,
      properties: {
        source,
        following_type: 'geography',
        following_id: geographyCode,
      },
    });

  const trackFollowingDrawerOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.FOLLOWING_DRAWER_OPEN,
      properties: {
        source,
      },
    });

  const trackFollowingTabViewed = (
    source: PosthogTrackingSource,
    tabType: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.FOLLOWING_TAB_VIEWED,
      properties: {
        source,
        tabType,
      },
    });

  const trackFollowingInsightClicked = (
    source: PosthogTrackingSource,
    followingType: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.FOLLOWING_INSIGHT_CLICKED,
      properties: {
        source,
        following_type: followingType,
      },
    });

  return {
    trackFollowTheme,
    trackUnfollowTheme,
    trackFollowGeography,
    trackUnfollowGeography,
    trackFollowingDrawerOpen,
    trackFollowingTabViewed,
    trackFollowingInsightClicked,
  };
};
